import React from "react";
import Blog from "../blog/Blog";
const BlogPage = () => {
  return (
    <div>
      <Blog />
    </div>
  );
};

export default BlogPage;
